import { render, staticRenderFns } from "./solicitud-evaluacion-hogar.vue?vue&type=template&id=73af5118&"
import script from "./solicitud-evaluacion-hogar.vue?vue&type=script&lang=ts&"
export * from "./solicitud-evaluacion-hogar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports